import { call, put, select, delay } from 'redux-saga/effects';
import { callWithAuth } from '../../sagaApiHelper';
import { getPhoneApi } from '../../../api/apiLists/getPhoneApi';
import { setWabaLoading, setWabaError, setPhones } from '../../whatsappSlice';
import { getPhoneFromStorage, savePhoneToStorage } from '../../../utils/apiCacheHelper';

export function* handleFetchPhones(action) {
  const { poll = false, forceRefresh = false } = action.payload || {};
  const maxPolls = 20;
  const pollInterval = 3000;

  for (let attempt = 0; attempt < (poll ? maxPolls : 1); attempt++) {
    try {
      yield put(setWabaLoading(true));
      yield put(setWabaError(null));

      const wabaAccounts = yield select(state => state.whatsapp.wabaAccounts);
      const wabaId = wabaAccounts.length > 0 ? wabaAccounts[0].wabaId : '';

      if (!wabaId) {
        yield put(setWabaError('No WABA ID available. Please ensure your WhatsApp Business Account is properly configured.'));
        yield put(setWabaLoading(false));
        if (poll && attempt < maxPolls - 1) {
          yield delay(pollInterval);
          continue;
        }
        return;
      }

      if (!forceRefresh) {
        const cachedPhones = getPhoneFromStorage(wabaId);
        if (cachedPhones) {
          yield put(setPhones(cachedPhones));
          yield put(setWabaLoading(false));
          return;
        }
      }

      const channelReq = {
        operation: 'GETPHONE',
        payload: { wabaId }
      };

      const channelRes = yield call(callWithAuth, getPhoneApi, channelReq);

      let phones = [];

      if (channelRes && channelRes.data && channelRes.data.success === true) {
        const apiData = channelRes.data.result || {};
        const rawPhones = Array.isArray(apiData.data) ? apiData.data : [];
        phones = rawPhones.map(phone => ({
          wabaPhoneId: phone.wabaPhoneId,
          wabaId: phone.wabaId,
          displayName: phone.displayName,
          displayPhoneNumber: phone.displayPhoneNumber,
          currentLimit: phone.currentLimit,
          qualityRating: phone.qualityRating,
          createdAt: phone.createdAt,
          updatedAt: phone.updatedAt,

          id: phone.wabaPhoneId,
          number: phone.displayPhoneNumber,
          label: phone.displayName,
          status: 'active'
        }));
        savePhoneToStorage(phones, wabaId);
      }

      yield put(setPhones(phones));

      if (Array.isArray(phones) && phones.length > 0) {
        break;
      }

      if (poll && attempt < maxPolls - 1) {
        yield delay(pollInterval);
        continue;
      }
    } catch (error) {
      console.error('Error fetching phone numbers:', error);
      yield put(setWabaError('Error occurred while fetching phone numbers'));
      if (poll && attempt < maxPolls - 1) {
        yield delay(pollInterval);
        continue;
      }
    } finally {
      yield put(setWabaLoading(false));
    }

    if (!poll) {
      break;
    }
  }
}
